module.exports = "./img/6ed393bc9c36cc439e49a982ef63de36.jpg";